import {Component, Input, OnInit} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {IPriceSummary} from "@models/sales-order.model";
import {UtilitiesService} from "@services/utilities.service";

@Component({
	selector: 'app-card-price-summary',
	templateUrl: './card-price-summary.component.html',
	styleUrls: ['./card-price-summary.component.scss']
})
export class CardPriceSummaryComponent implements OnInit {
	@Input() data: BehaviorSubject<IPriceSummary | null> = new BehaviorSubject<IPriceSummary | null>(null);
	@Input() showCard: boolean | null = true
	@Input() showInModal: boolean | null = false;

	constructor(
		public utilities: UtilitiesService,
	) {
	}

	ngOnInit(): void {
	}
}
